import Tooltip from "@/components/atoms/Tooltip/Tooltip";
import { CompletedIcon, FavouriteIcon, HideIcon } from "@/designSystemIcons";
import { BREAKPOINTS } from "@/settings";
import clsx from "clsx";
import React from "react";
import { useMediaQuery } from "usehooks-ts";

type Props = {
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  type: "favorite" | "hide" | "completed";
  state: "" | "hovered" | "active" | "disabled";
  disabled?: boolean;
  large?: boolean;
  gray?: boolean;
  disableToggle?: boolean;
};

const getIcon = (
  type: Props["type"],
  state: Props["state"],
  disabled?: boolean,
): React.ReactElement => {
  if (disabled) {
    switch (type) {
      case "favorite":
        return <FavouriteIcon />;
      case "completed":
        return <CompletedIcon fill="#646464" />;
      case "hide":
        return <HideIcon />;
    }
  }

  switch (type) {
    case "favorite":
      if (state === "active") return <FavouriteIcon fill="#03E46B" />;
      if (state === "hovered") return <FavouriteIcon fill="#fff" />;
      return <FavouriteIcon />;

    case "completed":
      if (state === "active") return <CompletedIcon fill="#03E46B" />;
      if (state === "hovered") return <CompletedIcon fill="#fff" />;
      return <CompletedIcon fill="#9CA6B2" />;

    case "hide":
      if (state === "active") return <HideIcon fill="#03E46B" />;
      if (state === "hovered") return <HideIcon fill="#fff" />;
      return <HideIcon />;
  }
};

const SBCToggle = ({
  onMouseEnter,
  onMouseLeave,
  onClick,
  type,
  state,
  disabled,
  large,
  disableToggle,
}: Props) => {
  const isTouchDevice = useMediaQuery(BREAKPOINTS.TOUCH_DEVICE.query);
  const icon = getIcon(type, state, disabled);

  return (
    <Tooltip
      content={
        type === "completed"
          ? disabled
            ? "Repeatable, so you can't complete it"
            : "Complete"
          : type === "favorite"
            ? "Favorite"
            : type === "hide"
              ? "Hide"
              : ""
      }
      delayDuration={150}
      side={"right"}
      disabled={isTouchDevice}
    >
      <button
        className={clsx(
          "flex items-center justify-center",
          large
            ? "w-8 h-10 desktop:w-10 desktop:h-12 mr-2"
            : "translate-x-1 w-8 h-8",
          (disabled || disableToggle) && "cursor-not-allowed",
        )}
        onMouseEnter={() => {
          if (!disableToggle) onMouseEnter?.();
        }}
        onMouseLeave={() => {
          if (!disableToggle) onMouseLeave?.();
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (!disableToggle && !disabled) onClick(e);
        }}
      >
        {icon}
      </button>
    </Tooltip>
  );
};

export default SBCToggle;
